export default __webpack_public_path__ + "static/media/edital1.e916002c.png";